<div id="{{id}}-period" class="inlineGroup fields" style="padding-top: 0;    padding-bottom: 0;">
    <field-item item="dataModel">
        <field-hcombo name="period" label="" options="periods" options-col="3" value="week"></field-hcombo>
    </field-item>
</div>